var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.68525 7.62459C8.39236 7.3317 7.91748 7.3317 7.62459 7.62459C7.3317 7.91748 7.3317 8.39236 7.62459 8.68525L8.68525 7.62459ZM9.90975 10.9704C10.2026 11.2633 10.6775 11.2633 10.9704 10.9704C11.2633 10.6775 11.2633 10.2026 10.9704 9.90975L9.90975 10.9704ZM8.61148 5.22078C8.61148 7.09341 7.09341 8.61148 5.22078 8.61148V10.1115C7.92184 10.1115 10.1115 7.92184 10.1115 5.22078H8.61148ZM5.22078 8.61148C3.34815 8.61148 1.83008 7.09341 1.83008 5.22078H0.330078C0.330078 7.92184 2.51972 10.1115 5.22078 10.1115V8.61148ZM1.83008 5.22078C1.83008 3.34815 3.34815 1.83008 5.22078 1.83008V0.330078C2.51972 0.330078 0.330078 2.51972 0.330078 5.22078H1.83008ZM5.22078 1.83008C7.09341 1.83008 8.61148 3.34815 8.61148 5.22078H10.1115C10.1115 2.51972 7.92184 0.330078 5.22078 0.330078V1.83008ZM7.62459 8.68525L9.90975 10.9704L10.9704 9.90975L8.68525 7.62459L7.62459 8.68525Z",
    fill: "#C1C4D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.fde0ee124f22d1c843a127e5eb13ce46.svg";
export { ForwardRef as ReactComponent };